import { z } from "zod";
/** Phase 1 evaluator status — separate from QualityGate CheckResult.passed until Phase 2 wiring. */
export const Phase1CheckStatusSchema = z.enum(["pass", "warn", "fail", "not_evaluated"]);
export const Phase1FindingSeveritySchema = z.enum(["info", "warn", "fail", "blocking"]);
export const Phase1CheckFindingV1Schema = z
    .object({
    code: z.string().min(1),
    severity: Phase1FindingSeveritySchema,
    clientSafeMessage: z.string().min(1),
    internalDetail: z.string().optional(),
})
    .strict();
export const Phase1CheckResultV1Schema = z
    .object({
    schemaVersion: z.literal("phase1-check-result.v1.0"),
    checkId: z.string().min(1),
    status: Phase1CheckStatusSchema,
    findings: z.array(Phase1CheckFindingV1Schema),
    evaluatedAt: z.string().datetime().optional(),
    clientSafeSummary: z.string().min(1),
    internalSummary: z.string().optional(),
})
    .strict();
export function resolvePhase1StatusFromFindings(findings) {
    if (findings.some((f) => f.severity === "blocking" || f.severity === "fail")) {
        return "fail";
    }
    if (findings.some((f) => f.severity === "warn")) {
        return "warn";
    }
    return "pass";
}
//# sourceMappingURL=phase1-check-result.js.map